import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { API_BASE } from '../api/client';

interface NewsItem { id: number; title: string; description: string; imageS3: string | null; createdAt: string; regionId: number | null; }
interface Region { id: number; name: string; }

export default function NewsDetailPage() {
  const { t, i18n } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [news, setNews] = useState<NewsItem | null>(null);
  const [region, setRegion] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const locale = i18n.language === 'en' ? 'en-US' : i18n.language === 'ky' ? 'ky-KG' : 'ru-RU';

  useEffect(() => {
    Promise.all([axios.get(`${API_BASE}/news/${id}`), axios.get(`${API_BASE}/regions`)])
      .then(([newsRes, regRes]) => {
        setNews(newsRes.data);
        const found = regRes.data.find((r: Region) => r.id === newsRes.data.regionId);
        setRegion(found?.name || '');
      }).catch(() => navigate('/news')).finally(() => setLoading(false));
  }, [id, navigate]);

  if (loading) return <div style={s.loading}>{t('news_loading')}</div>;
  if (!news) return null;

  return (
    <div style={s.page}>
      <button onClick={() => navigate('/news')} style={s.back}>{t('news_back')}</button>
      {news.imageS3 && <img src={`${API_BASE}/news/media/${news.imageS3}`} alt={news.title} style={s.image} />}
      <div style={s.meta}>
        {region && <span style={s.region}>📍 {region}</span>}
        <span style={s.date}>{news.createdAt ? new Date(news.createdAt).toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric' }) : ''}</span>
      </div>
      <h1 style={s.title}>{news.title}</h1>
      <div style={s.body}>{news.description}</div>
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  page: { maxWidth: 800, margin: '0 auto', padding: '48px 40px' },
  loading: { textAlign: 'center', padding: 80, color: '#888' },
  back: { background: 'none', border: 'none', color: '#1a3a6b', fontSize: '0.95rem', cursor: 'pointer', fontWeight: 600, marginBottom: 28, padding: 0 },
  image: { width: '100%', maxHeight: 420, objectFit: 'cover', borderRadius: 10, marginBottom: 28 },
  meta: { display: 'flex', gap: 16, alignItems: 'center', marginBottom: 16 },
  region: { fontSize: '0.85rem', color: '#1a3a6b', fontWeight: 600 },
  date: { fontSize: '0.85rem', color: '#999' },
  title: { fontSize: '1.9rem', color: '#1a2a4a', fontWeight: 700, lineHeight: 1.3, marginBottom: 24 },
  body: { fontSize: '1.05rem', color: '#333', lineHeight: 1.9, whiteSpace: 'pre-wrap' },
};
